<template>
  <NumeraiModal
    ref="modal"
    title="Manage Link"
    button-text="Manage Link"
    :fields="fields"
    :save-callback="save"
    :disabled="fetching"
    @close="close"
  >
    <template v-slot:activator>
      <slot>
        <span class="bio">{{
          (profile.bio ? '+ edit' : '+ add') + ' link'
        }}</span>
      </slot>
    </template>
    Add a custom link to your profile
    <v-row class="ma-0 mt-6" justify="center">
      <input
        v-model="fields.value1"
        type="text"
        placeholder="Link Title"
        class="text"
        maxlength="26"
      />
      <input
        v-model="fields.value2"
        type="text"
        placeholder="Link URL"
        class="text"
      />
    </v-row>
    <span>{{ msg }}</span>
  </NumeraiModal>
</template>

<script>
import { mapActions } from 'vuex'

import NumeraiModal from '@/components/shared/NumeraiModal'
const defaultFields = {
  value1: '',
  value2: '',
}
export default {
  components: {
    NumeraiModal,
  },
  props: {
    modelId: { type: String, default: null },
    profile: { type: Object, default: null },
    fetchProfile: { type: Function, default: null },
  },
  data() {
    return {
      fields: {
        ...defaultFields,
      },
      msg: '',
      fetching: false,
    }
  },
  async created() {
    try {
      const text = this.profile.linkText
      const url = this.profile.linkUrl
      this.fields.value1 = text || ''
      this.fields.value2 = url || ''
    } catch (e) {
      this.showSnackBar({ msg: e.message })
    }
  },
  methods: {
    ...mapActions(['showSnackBar']),
    close() {
      this.fields = {
        ...defaultFields,
      }
      this.msg = ''
    },
    open() {
      this.$refs.modal.open()
    },
    async save() {
      this.msg = ''
      this.fetching = true
      if (
        (!this.fields.value1 && this.fields.value2) ||
        (this.fields.value1 && !this.fields.value2)
      ) {
        this.msg = 'Fill both fields'
      } else {
        try {
          await this.$client.setUserLink({
            text: this.fields.value1,
            url: this.fields.value2,
            modelId: this.modelId,
          })

          await this.fetchProfile(this.$route.params.username)
          this.showSnackBar({
            msg: `Link updated`,
          })
          this.$refs.modal.close()
          this.fields = {
            ...defaultFields,
          }
        } catch (e) {
          this.msg = e.message
        }
      }
      this.fetching = false
    },
  },
}
</script>

<style scoped lang="scss">
.text {
  color: var(--color-secondary);
  border: 1px solid #9e9e9e;
  padding: 10px;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 16px;
}
</style>
